const CLUB_REFERER = 'club'

export const hasValidReferer = () => {
  const queryString = window.location.search

  const urlParams = new URLSearchParams(queryString)

  if (urlParams.has('referer')) {
    const refererValue = urlParams.get('referer')

    return refererValue?.toLowerCase().trim() === CLUB_REFERER
  }
  return false
}

export const isLogoutRoute = () => {
  const pathname = window.location.pathname

  return pathname.includes('auth/logout')
}

